import { render } from "./landingPage-footer.vue?vue&type=template&id=5d0d69b2&scoped=true"
import script from "./landingPage-footer.vue?vue&type=script&lang=js"
export * from "./landingPage-footer.vue?vue&type=script&lang=js"

import "../pages/landing-page.scss?vue&type=style&index=0&lang=scss&external"
import "./landingPage-footer.vue?vue&type=style&index=1&id=5d0d69b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0d69b2"]])

export default __exports__